import { datadogRum } from '@datadog/browser-rum';
import appConfig from 'app-config';

  datadogRum.init({
    applicationId: '65d5097b-36e7-43d6-846d-67809604f493',
    clientToken: 'pub2c3e56a759c3f00de462e0dc6fda9be0',
    site: 'datadoghq.com', // or 'datadoghq.eu', 'us3.datadoghq.com', etc.
    service: appConfig.productName,
    env: appConfig.cloudEnv.planet,
    version: '1.0.0', // or use package.json version
    sampleRate: 100,
    trackInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    enablePrivacyForActionName: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  // Uncomment if Session Replay is availible 
  // datadogRum.startSessionReplayRecording();

  const getRumSessionId = () =>
    datadogRum.getInternalContext()?.session_id;

export {
  datadogRum,
  getRumSessionId
};

